"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_ROLES = exports.SET_USERS = void 0;
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
exports.SET_USERS = "@@USERS/SET_USERS";
exports.USER_ROLES = [
    { label: i18n_1.default.t("Permission_level")["admin"], value: "admin" },
    { label: i18n_1.default.t("Permission_level")["user"], value: "user" },
];
